export default __webpack_public_path__ + "static/media/certificate.a24694c0.pdf";